<template>
  <v-main>
    <v-app-bar app flat light color="white">
      <AppbarBackIcon />
      <v-toolbar-title class="font-weight-bold">数据导入</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" text :href="DocLink.BALANCE_TASK" target="_blank">查看教程</v-btn>
      <v-btn icon color="black" @click="onCreate" class="ml-4">
        <v-icon>{{ mdiPlus }}</v-icon>
      </v-btn>
    </v-app-bar>
    <v-list>
      <v-list-item :key="task.id" v-for="task in taskList" @click="onItemClick(task.id)">
        <v-list-item-title>{{ task.title }}</v-list-item-title>
        <v-list-item-title>{{ getBalanceTaskStatusName(task.status) }}</v-list-item-title>
        <v-list-item-title>{{ task.dt_created }}</v-list-item-title>
        <v-icon>{{ mdiChevronRight }}</v-icon>
      </v-list-item>
    </v-list>
  </v-main>
</template>

<script>
import AppbarBackIcon from '@/components/AppbarBackIcon.vue'
import { mdiArrowLeft, mdiPlus, mdiChevronRight } from '@mdi/js'
import { homeStore } from '@/store/home'
import { balanceTaskStore } from '@/store/balanceTask'
import { getBalanceTaskStatusName } from '@/plugins/balanceTask'
import { DocLink } from '@/plugins/doc'

export default {
  name: 'BalanceTaskPage',
  components: { AppbarBackIcon },
  data() {
    return {
      mdiArrowLeft,
      mdiPlus,
      mdiChevronRight,
      DocLink,
    }
  },
  computed: {
    taskList() {
      return balanceTaskStore.list
    },
  },
  async mounted() {
    await homeStore.doLoad()
    await balanceTaskStore.doLoad()
  },
  methods: {
    getBalanceTaskStatusName,
    onCreate() {
      this.$router.push('/dash/balance-task-detail')
    },
    onItemClick(taskId) {
      this.$router.push({
        path: '/dash/balance-task-detail',
        query: { id: taskId },
      })
    },
  },
}
</script>

<style></style>
